import { getFoods } from "services"
import refactorFoods from "./refactorFoods"
import { store, updateFoods, updateFoodsInCategoryGroup } from "@redux"

const getRequestItemsMap = (requestItems) => {
  const requestItemsMap = {}

  requestItems.forEach(requestItem => {
    requestItemsMap[requestItem.optionId] = requestItem
  })

  return requestItemsMap
}

const getLatestFoodsMap = async (requestItems, branchId) => {
  const foodIds = []

  requestItems.forEach(requestItem =>
    foodIds.push(requestItem.foodId)
  )

  const response =
    await getFoods({
      foodIds,
      branchId,
      limit: foodIds.length
    })

  const latestFoods =
    refactorFoods(response, branchId)

  store.dispatch(
    updateFoodsInCategoryGroup(latestFoods)
  )

  store.dispatch(
    updateFoods(latestFoods)
  )

  const latestFoodsMap = {}

  latestFoods.forEach(latestFood => {
    const { options, ...foodDetails } = latestFood

    latestFood.options.forEach(option => {
      latestFoodsMap[option._id] = {
        ...foodDetails,
        option,
        isSimple: latestFood.options.length === 1
      }
    })
  })

  return latestFoodsMap
}

const isFoodOutOfStock = (latestFood, requestItem) => {
  if (!latestFood) {
    return {
      type: "deletedFood",
      isSimple: requestItem.isSimple,
      foodName: requestItem.foodName,
      optionName: requestItem.optionName
    }
  }

  const isOutOfStock =
    latestFood.option.isAvailable
      ?
      latestFood.option.outOfStock ||
      (
        latestFood.option.stockManagement &&
        latestFood.option.availableQuantity <= 0
      )
      :
      true

  if (isOutOfStock) {
    return {
      type: "deletedFood",
      isSimple: requestItem.isSimple,
      foodName: requestItem.foodName,
      optionName: requestItem.optionName
    }
  }

  return null
}

const isFoodStockLimited = (latestFood, requestItem) => {
  if (!latestFood.option.stockManagement)
    return null

  const availableQuantity =
    latestFood.option.availableQuantity

  if (requestItem.acceptedQuantity > availableQuantity) {
    return {
      type: "limitedFood",
      unit: latestFood.unit,
      foodName: latestFood.name,
      isSimple: latestFood.isSimple,
      optionName: latestFood.option.name,
      stockManagement: latestFood.option.stockManagement,
      availableQuantity: availableQuantity
    }
  }

  return null
}

const validateStockTransferContents = async (requestItems, branchId) => {
  const latestFoodsMap =
    await getLatestFoodsMap(requestItems, branchId)

  const requestItemsMap =
    getRequestItemsMap(requestItems)

  const problematicItems = []

  const optionIds =
    Object.keys(requestItemsMap)

  optionIds.forEach(optionId => {
    const latestFood = latestFoodsMap[optionId]

    const outOfStockItem =
      isFoodOutOfStock(
        latestFood,
        requestItemsMap[optionId]
      )

    if (outOfStockItem !== null) {
      problematicItems.push(outOfStockItem)

      return
    }

    const limitedStockItem =
      isFoodStockLimited(
        latestFood,
        requestItemsMap[optionId]
      )

    if (limitedStockItem !== null) {
      problematicItems.push(limitedStockItem)

      return
    }
  })

  return problematicItems
}

export default validateStockTransferContents